<template>
  <div :class="klass">
    <p :class="colorTextClass">
      <v-icon :color="colorIcon" :icon="getIcon()"/>
      {{ message }}
    </p>
  </div>
</template>

<script setup>
  const props = defineProps({
    colorTextClass: {
      type: String,
      default: '',
    },
    colorIcon: {
      type: String,
      default: 'gray',
    },
    message: { type: String, default: '' },
    icon: { type: String, default: '' },
    klass: { type: String, default: '' },
  });

  const getIcon = () => {
    if (props.icon === 'info') {
      return 'mdi-information';
    }
    else if (props.icon === 'error') {
      return 'mdi-alert-octagon-outline';
    }
    else if (props.icon === 'check') {
      return 'mdi-check-circle-outline';
    }
    else if (props.icon === 'warning') {
      return 'mdi-alert';
    }
    return props.icon;
  };
</script>
